import { createFileRoute, Link } from "@tanstack/react-router";
import { requireAdmin } from "@/lib/admin-guard";
import { ArrowLeft, Users } from "lucide-react";
import { EscalationPathwayContent } from "@/components/EscalationPathwayContent";

export const Route = createFileRoute("/admin_/escalation-pathway")({
  ssr: false,
  head: () => ({
    meta: [
      { title: "Escalation Pathway — Admin" },
      { name: "robots", content: "noindex,nofollow" },
    ],
  }),
  beforeLoad: requireAdmin,
  component: EscalationPathwayPage,
});

function EscalationPathwayPage() {
  return (
    <div className="mx-auto max-w-5xl px-4 py-10 sm:px-6">
      <div className="mb-6 flex flex-wrap items-center justify-between gap-3">
        <Link
          to="/admin"
          className="inline-flex items-center gap-2 text-sm font-medium text-foreground/70 hover:text-foreground"
        >
          <ArrowLeft className="h-4 w-4" />
          Back to Admin
        </Link>
        <Link
          to="/admin/team-roles"
          className="inline-flex items-center gap-2 rounded-lg border border-gold/30 bg-card px-3 py-2 text-sm font-medium text-foreground hover:bg-gold/10"
        >
          <Users className="h-4 w-4" />
          Team Roles & Job Descriptions
        </Link>
      </div>

      <EscalationPathwayContent />
    </div>
  );
}
